import AbstractFilter from './AbstractFilter';

export default class StringTrim extends AbstractFilter
{
    filter(value: string | number): string
    {
        if (typeof value === 'undefined' || value === null)
        {
            return '';
        }

        return value.toString().trim();
    }
}